import React from "react";
import { LoadingState as SharedLoadingState, SkeletonCards } from "components/ui/loading-state";

/**
 * Adapter over the shared loading scaffolds.
 *
 * The original hand-drew ~90 lines of `bg-gray-200 animate-pulse` divs with no
 * dark-mode variant, so the placeholders stayed light grey on a dark canvas
 * and the whole page flashed on theme switch. The shared skeletons resolve
 * through the token layer instead.
 */
const LoadingState: React.FC = () => (
    <div className="space-y-5">
        {/* Toolbar placeholder */}
        <SharedLoadingState shape="text" count={1} label="Loading templates" />
        {/* Gallery placeholder — mirrors the real 4-up card grid */}
        <SkeletonCards count={12} columns={4} media />
    </div>
);

export default LoadingState;
